import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={101}
    height={props.width? `calc( ${props.width}/ 101 * 101 )`: 101}
    viewBox="0 0 101 101"
    fill="none"
    {...props}
  >
    <path
      fill="url(#aee)"
      stroke="#F90"
      d="M74.745 7.266 99.471 50.5 74.745 93.734H25.301L.577 50.5 25.302 7.266h49.443Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m50.376 15-6.14 20.206 6.14 3.99 6.138-3.99L50.376 15ZM74.22 23.697l-17.706 11.51 2.128 7.005 7.266.897 8.312-19.412Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M86.873 45.697 65.912 43.12l-2.878 6.733 4.985 5.361 18.853-9.516Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M82.386 70.703 68.02 55.213l-6.55 3.32.35 7.334 20.566 4.836Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m63.053 87-1.105-21.09-7.129-1.665-4.413 5.84L63.053 87Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m37.703 86.99 12.733-16.85-4.386-5.863-7.137 1.628-1.21 21.085Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m18.318 70.58 20.587-4.709.415-7.309-6.512-3.346-14.49 15.365Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m14.023 45.566 18.784 9.653 5.022-5.326-2.828-6.754-20.978 2.427Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m26.236 24.14 8.818 19.19 7.24-1.088 1.942-7.06-18-11.043Z"
    />
    <defs>
      <radialGradient
        id="aee"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-50.0236 0 0 -50.5 50.023 50.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" stopOpacity={0.5} />
        <stop offset={1} stopColor="#FFB800" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
)
export default SvgComponent
